import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { ITimeStyle } from "../../../../documaker/domain/format/objects";

export interface ITimeStylePropertyEditable {
  timeStyle(): IPropertyEditable<ITimeStyle>;
}

export function instanceOfITimeStylePropertyEditable(instance: any): instance is ITimeStylePropertyEditable {
  return instance
      && instance.timeStyle
      && instanceOfIPropertyEditable<ITimeStyle>(instance.timeStyle());
}
